"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var projectedX = exports.projectedX = "x";
var projectedY = exports.projectedY = "y";
var projectedYMiddle = exports.projectedYMiddle = "yMiddle";
var projectedYTop = exports.projectedYTop = "yTop";
var projectedYBottom = exports.projectedYBottom = "yBottom";
var projectedXMiddle = exports.projectedXMiddle = "xMiddle";
var projectedXTop = exports.projectedXTop = "xTop";
var projectedXBottom = exports.projectedXBottom = "xBottom";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/constants/coordinateNames.js
// module id = 300
// module chunks = 0